/* ============================================
   LATESTINSIGHTS.JSX - COMPONENT FILE
   📁 File location: src/components/LatestInsights.jsx
   📝 Properties ko showcase karta hai with scroll
   ============================================ */

import React, { useState, useRef, useContext, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ExternalLink } from 'lucide-react';
import '../../../../assets/css/Buyer/Home/propertyInsight.css'; // ⭐ CSS file import
import { useNavigate } from 'react-router-dom';
import AppContext from 'context/AppContext';
import axios from 'axios';

/* ============================================
   LATEST INSIGHTS COMPONENT
   ============================================ */
function PropertyInsight() {

  /* ========================================
     🎯 STATE & REFS
     ======================================== */
  const [activeTab, setActiveTab] = useState('sell'); // Active tab: sell or rent
  const scrollContainerRef = useRef(null); // Scroll container reference
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles,authToken } = useContext(AppContext);

  const [blogPosts, setBlogPosts] = useState([]);

  const viewAllBuyerBlogs = () => {
    axios
      .post(`${baseUrl}/buyer/buyerblogs/viewAllBuyerBlogs`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        setBlogPosts(response.data.blogs || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllBuyerBlogs();
  }, []);

//   const sellBlogs = blogPosts.filter(
//   (blog) => blog.category?.toLowerCase() === "sell"
// );

// const rentBlogs = blogPosts.filter(
//   (blog) => blog.category?.toLowerCase() === "rent"
// );
  // const propertiesData = {
  //   sell: [
  //     {
  //       id: 1,
  //       title: 'Luxury Villa in DHA',
  //       date: '01 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&h=600&fit=crop',
  //       articleCount: '08 articles',
  //     },
  //     {
  //       id: 2,
  //       title: 'Modern Apartment Complex',
  //       date: '14 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=600&fit=crop',
  //       articleCount: '04 articles',
  //     },
  //     {
  //       id: 3,
  //       title: 'Residential Design Future',
  //       date: '01 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&h=600&fit=crop',
  //       articleCount: '21 articles',
  //     },
  //     {
  //       id: 4,
  //       title: 'The Future of Architecture',
  //       date: '01 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=800&h=600&fit=crop',
  //       articleCount: '16 articles',
  //     },
  //     {
  //       id: 5,
  //       title: 'Commercial Plaza Downtown',
  //       date: '15 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop',
  //       articleCount: '12 articles',
  //     },
  //   ],
  //   rent: [
  //     {
  //       id: 6,
  //       title: 'Furnished Apartment',
  //       date: '20 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&h=600&fit=crop',
  //       articleCount: '05 articles',
  //     },
  //     {
  //       id: 7,
  //       title: 'Office Space Available',
  //       date: '18 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop',
  //       articleCount: '09 articles',
  //     },
  //     {
  //       id: 8,
  //       title: 'Cozy Studio Apartment',
  //       date: '22 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1502672260066-6bc35f0c8024?w=800&h=600&fit=crop',
  //       articleCount: '07 articles',
  //     },
  //     {
  //       id: 9,
  //       title: 'Warehouse for Rent',
  //       date: '25 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop',
  //       articleCount: '03 articles',
  //     },
  //     {
  //       id: 10,
  //       title: 'Retail Shop Space',
  //       date: '28 Nov 2024',
  //       image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=600&fit=crop',
  //       articleCount: '11 articles',
  //     },
  //   ],
  // };

  /* Current properties based on active tab */
  // const currentProperties = activeTab === "sell" ? sellBlogs : rentBlogs;
  const currentProperties = blogPosts;

  /* ========================================
     🎬 EVENT HANDLERS
     ======================================== */

  /* Tab change handler - Sell ya Rent select karna */
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Reset scroll to start
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft = 0;
    }
  };

  /* Scroll left - Previous button */
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -400, // 400px left scroll
        behavior: 'smooth',
      });
    }
  };

  /* Scroll right - Next button */
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 400, // 400px right scroll
        behavior: 'smooth',
      });
    }
  };

  /* ========================================
     🎨 JSX RETURN - Component structure
     ======================================== */
  return (
    <section className="estate-insights-section">
      <div className="estate-insights-container">

        {/* ========================================
             HEADER - Blog label + Heading + View Blog button
             ======================================== */}
        <div className="estate-insights-header">
          <div className="estate-insights-header-left">
            {/* Blog label */}
            <span className="estate-blog-label">● Blog</span>

            {/* Main heading */}
            <h2 className="estate-insights-heading">Latest Insights</h2>
          </div>

          {/* View Blog button - Top right */}
          <button className="estate-view-blog-btn"
            onClick={() => navigate("/blogs")}
          >View Blog</button>
        </div>

        {/* ========================================
             PROPERTIES SCROLL CONTAINER
             Horizontal scroll with cards
             ======================================== */}
        <div
          className="estate-properties-scroll-container"
          ref={scrollContainerRef}
        >
          <div className="estate-properties-grid">
            {currentProperties.map((property) => (
              <div key={property.id} className="estate-property-card">
                {/* Property image with overlay */}
                <div className="estate-property-image-container">
                  <img            
                    src={`${baseUrlForFiles}${property.image}`}
                    alt={property.title}
                  className="estate-property-image"
                  />

                  {/* Overlay gradient */}
                  <div className="estate-property-overlay"></div>

                  {/* External link icon - Top right of card */}
                  <button className="estate-external-link-btn">
                    <ExternalLink size={20} />
                  </button>

                  {/* Property info - Bottom of image */}
                  <div className="estate-property-info">
                    <p className="estate-property-date">{new Date(property?.created_at).toLocaleDateString()}</p>
                    <h3 className="estate-property-title">{property.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ========================================
             NAVIGATION ARROWS
             Bottom center - Previous aur Next buttons
             ======================================== */}
        <div className="estate-navigation-arrows">
          {/* Previous button */}
          <button
            className="estate-arrow-btn estate-arrow-left"
            onClick={scrollLeft}
            aria-label="Previous"
          >
            <ChevronLeft size={24} />
          </button>

          {/* Next button */}
          <button
            className="estate-arrow-btn estate-arrow-right"
            onClick={scrollRight}
            aria-label="Next"
          >
            <ChevronRight size={24} />
          </button>
        </div>
      </div>
    </section>
  );
}

export default PropertyInsight;